import { Link } from "react-router-dom";
import { Image, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    logo: {
		display: "flex",
		alignItems: "center",
		textDecoration: "none"
	}
});

const NavigationMenuLogo = () => {
    const { t } = useTranslation("general");
    const styles = useStyles();
    
    return (
        <Link to="/">
            <Image
                src="/img/logos/dolphin-solutions_logo_blue-black.png"
                alt={t("companyName")}
                className={styles.logo}
                width={185}
                height={60}
                />
        </Link>
    );
};

export default NavigationMenuLogo;